import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { getSpacing } from '../../const/spacing';
import { transitionDuration } from '../../const/transitionDuration';
import { useTextStyle } from '../Text/useTextStyle';
import { inputPaddingTopInRem } from './InputBase/inputBaseConst';
export const INPUT_TEXT_VARIANT = 's1';
const getInputBackgroundColor = (readOnly, warning) => {
    if (warning)
        return staticColors.inputWarningBackground;
    return readOnly
        ? staticColors.inputReadOnlyBackground
        : staticColors.inputBackground;
};
export const useCommonInputStyle = (readOnly, warning = false) => {
    const textStyle = useTextStyle({
        font: 'primary',
        variant: INPUT_TEXT_VARIANT,
        color: 'dark',
        underline: false,
    });
    return {
        ...textStyle,
        outline: 'none',
        borderTopWidth: 0,
        borderRightWidth: 0,
        borderLeftWidth: 0,
        borderStyle: 'solid',
        backgroundColor: getInputBackgroundColor(readOnly, warning),
        cursor: 'auto',
        caretColor: staticColors.inputCaret,
    };
};
const getBorderColor = (isFocused, warning) => {
    if (warning)
        return staticColors.inputWarningBorder;
    return isFocused
        ? staticColors.inputFocusedBorder
        : staticColors.inputUnfocusedBorder;
};
const getCommonBorderStyle = (isFocused, warning = false) => {
    return {
        borderTopWidth: 0,
        borderRightWidth: 0,
        borderBottomWidth: sizes.input.underlineWidth,
        borderLeftWidth: 0,
        borderStyle: 'solid',
        borderTopLeftRadius: sizes.input.borderRadius,
        borderTopRightRadius: sizes.input.borderRadius,
        transitionProperty: 'border-color',
        transitionDuration: transitionDuration.short,
        borderColor: getBorderColor(isFocused, warning),
        paddingLeft: getSpacing('1'),
        paddingRight: getSpacing('1'),
        paddingBottom: getSpacing('1/2'),
        paddingTop: inputPaddingTopInRem,
    };
};
export const useNormalInputBaseStyle = ({ readOnly = false, isLink, warning = false, }) => {
    const commonStyle = useCommonInputStyle(readOnly, warning);
    const plainButtonLinkStyle = {
        textDecoration: 'underline',
        cursor: 'pointer',
    };
    return {
        ...commonStyle,
        borderBottomWidth: 0,
        width: '100%',
        ...(isLink && plainButtonLinkStyle),
    };
};
export const useNormalInputWrapperStyle = ({ isFocused, readOnly = false, warning = false, }) => {
    const commonBorderStyle = getCommonBorderStyle(isFocused, warning);
    return {
        ...commonBorderStyle,
        backgroundColor: getInputBackgroundColor(readOnly, warning),
    };
};
export const useInputStyle = ({ isFocused, readOnly = false, warning = false, }) => {
    const commonStyle = useCommonInputStyle(readOnly, warning);
    const commonBorderStyle = getCommonBorderStyle(isFocused, warning);
    return {
        ...commonStyle,
        ...commonBorderStyle,
    };
};
